/* Ashara premium interactions: tabs, add-to-bag, wishlist, search hints, app bar counts */
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var WL_KEY = 'aj_wishlist';

  function wlGet() { try { return JSON.parse(localStorage.getItem(WL_KEY) || '[]'); } catch (e) { return []; } }
  function wlSet(list) { try { localStorage.setItem(WL_KEY, JSON.stringify(list)); } catch (e) {} }

  function toast(html) {
    var t = document.querySelector('.aj-toast');
    if (!t) { t = document.createElement('div'); t.className = 'aj-toast'; document.body.appendChild(t); }
    t.innerHTML = html; t.classList.add('show');
    clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('show'); }, 2600);
  }

  function setCounts(cartCount) {
    var wl = wlGet().length;
    document.querySelectorAll('[data-aj-wl-count]').forEach(function (el) { el.textContent = wl ? wl : ''; });
    if (typeof cartCount === 'number') {
      document.querySelectorAll('[data-aj-cart-count]').forEach(function (el) { el.textContent = cartCount ? cartCount : ''; });
    }
    tidyCartBubble();
  }

  function paintHearts(scope) {
    var list = wlGet();
    (scope || document).querySelectorAll('[data-aj-wish]').forEach(function (b) {
      var on = list.indexOf(b.getAttribute('data-aj-wish')) > -1;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  document.addEventListener('click', function (e) {
    /* tabs */
    var tab = e.target.closest('[data-aj-tab]');
    if (tab) {
      var box = tab.closest('[data-aj-tabs]');
      var i = tab.getAttribute('data-aj-tab');
      box.querySelectorAll('[data-aj-tab]').forEach(function (b) { b.classList.toggle('is-on', b === tab); });
      box.querySelectorAll('[data-aj-panel]').forEach(function (p) { p.hidden = p.getAttribute('data-aj-panel') !== i; });
      var more = box.querySelector('[data-aj-more]');
      if (more && tab.dataset.url) more.href = tab.dataset.url;
      return;
    }
    /* wishlist */
    var w = e.target.closest('[data-aj-wish]');
    if (w) {
      e.preventDefault();
      var h = w.getAttribute('data-aj-wish'), list = wlGet(), idx = list.indexOf(h);
      if (idx > -1) { list.splice(idx, 1); toast('Removed from wishlist'); }
      else { list.unshift(h); toast('Saved to wishlist <a href="' + root + 'pages/wishlist">View</a>'); }
      wlSet(list); paintHearts(); setCounts();
      if (idx > -1 && document.getElementById('aj-wishlist')) renderWishlist();
      return;
    }
    /* add to bag */
    var a = e.target.closest('[data-aj-add]');
    if (a) {
      e.preventDefault();
      var plus = a.classList.contains('aj-card__plus');
      a.classList.add('is-busy'); var label = a.textContent; if (!plus) a.textContent = 'Adding…';
      fetch(root + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(a.getAttribute('data-aj-add'), 10), quantity: 1 }], sections: 'cart-icon-bubble' })
      }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function (j) {
          if (j.sections && j.sections['cart-icon-bubble']) {
            var bubble = document.getElementById('cart-icon-bubble');
            if (bubble) {
              var d = new DOMParser().parseFromString(j.sections['cart-icon-bubble'], 'text/html');
              var src = d.querySelector('.shopify-section') || d.body;
              bubble.innerHTML = src.innerHTML;
            }
          }
          a.textContent = plus ? '✓' : 'Added ✓';
          return fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (c) { setCounts(c.item_count); miniCart(j.items ? j.items[0] : j, c); });
        })
        .catch(function (err) { a.textContent = label; toast((err && err.description) || 'Could not add. Please try again.'); })
        .finally(function () { setTimeout(function () { a.classList.remove('is-busy'); a.textContent = label; }, 1600); });
    }
  });

  /* mini cart: stay on the page after adding, nudge toward Buy 2 Get 1 */
  function money(p) { return '₹' + Math.round(p / 100).toLocaleString('en-IN'); }
  function esc(s) { return String(s || '').replace(/[&<>"]/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch]; }); }
  function miniCart(item, cart) {
    var el = document.querySelector('.aj-mc');
    if (!el) {
      el = document.createElement('div'); el.className = 'aj-mc'; el.setAttribute('role', 'dialog'); el.setAttribute('aria-label', 'Added to bag');
      document.body.appendChild(el);
      el.addEventListener('click', function (e) { if (e.target === el || e.target.closest('[data-mc-close]')) { e.preventDefault(); el.classList.remove('is-on'); } });
      if (!document.getElementById('aj-mc-css')) {
        var st = document.createElement('style'); st.id = 'aj-mc-css';
        st.textContent = '.aj-mc{position:fixed;inset:0;z-index:2147483000;background:rgba(36,28,26,.35);opacity:0;visibility:hidden;transition:opacity .2s}.aj-mc.is-on{opacity:1;visibility:visible}'
          + '.aj-mc__card{position:absolute;left:0;right:0;bottom:0;background:#fff;border-radius:16px 16px 0 0;padding:16px 16px calc(16px + env(safe-area-inset-bottom));transform:translateY(100%);transition:transform .25s ease;font-family:var(--font-body-family);color:#241c1a}.aj-mc.is-on .aj-mc__card{transform:none}'
          + '.aj-mc__top{display:flex;justify-content:space-between;align-items:center;margin-bottom:12px;font-size:15px;font-weight:600;color:#1e7b34}.aj-mc__top button{background:none;border:0;font-size:24px;line-height:1;color:#6f625a;cursor:pointer;padding:0 4px}'
          + '.aj-mc__item{display:flex;gap:12px;align-items:center}.aj-mc__item img{width:64px;height:64px;object-fit:cover;border-radius:8px;background:#f7f3ef}.aj-mc__item b{display:block;font-size:14px;font-weight:500;line-height:1.35}.aj-mc__item span{display:block;font-size:13px;color:#6f625a;margin-top:2px}'
          + '.aj-mc__offer{margin:14px 0;padding:10px 12px;border-radius:10px;background:#faf1e6;font-size:13px;color:#5a4e48}.aj-mc__offer b{color:#6b1e2e}.aj-mc__bar{height:6px;margin-top:8px;border-radius:6px;background:#eadccb;overflow:hidden}.aj-mc__bar i{display:block;height:100%;background:#6b1e2e;border-radius:6px}'
          + '.aj-mc__btns{display:grid;grid-template-columns:1fr 1fr;gap:10px}.aj-mc__btns a,.aj-mc__btns button{display:flex;align-items:center;justify-content:center;height:48px;border-radius:8px;font:inherit;font-size:14px;font-weight:600;letter-spacing:.04em;text-transform:uppercase;text-decoration:none;cursor:pointer}.aj-mc__btns a{background:#6b1e2e;color:#fff;border:1px solid #6b1e2e}.aj-mc__btns button{background:#fff;color:#241c1a;border:1px solid #241c1a}'
          + '@media(min-width:750px){.aj-mc__card{left:auto;right:24px;bottom:auto;top:90px;width:380px;border-radius:14px;transform:translateY(-12px);box-shadow:0 18px 40px rgba(0,0,0,.18)}}';
        document.head.appendChild(st);
      }
    }
    var n = cart ? cart.item_count : 1, free = Math.floor(n / 3), rem = 3 - (n % 3), pct = n % 3 === 0 ? 100 : Math.round((n % 3) * 100 / 3);
    var msg = free === 0 ? 'Add <b>' + rem + ' more</b> and get <b>1 FREE</b> (Buy 2 Get 1)' : (n % 3 === 0 ? '🎉 <b>' + free + ' FREE</b> piece' + (free > 1 ? 's' : '') + ' unlocked! Add 3 more for another' : '🎉 <b>' + free + ' FREE</b> unlocked · add <b>' + rem + ' more</b> for another');
    var img = item && (item.featured_image && item.featured_image.url || item.image) || '';
    if (img && img.indexOf('?') === -1) img += '?width=160'; else if (img) img += '&width=160';
    var variant = item && item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
    el.innerHTML = '<div class="aj-mc__card"><div class="aj-mc__top"><span>✓ Added to bag</span><button type="button" data-mc-close aria-label="Close">×</button></div>'
      + (item ? '<div class="aj-mc__item">' + (img ? '<img src="' + esc(img) + '" alt="">' : '') + '<div><b>' + esc(item.product_title || item.title) + '</b>' + (variant ? '<span>' + esc(variant) + '</span>' : '') + '<span>' + money(item.final_price || item.price) + '</span></div></div>' : '')
      + '<div class="aj-mc__offer">' + msg + '<div class="aj-mc__bar"><i style="width:' + pct + '%"></i></div></div>'
      + '<div class="aj-mc__btns"><button type="button" data-mc-close>Continue shopping</button><a href="' + root + 'cart">View bag (' + n + ')</a></div></div>';
    requestAnimationFrame(function () { el.classList.add('is-on'); });
    clearTimeout(el._t);
  }
  window.ajMiniCart = miniCart;
  /* product page Add to Cart: add in the background instead of jumping to the cart page */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.matches || !f.matches('form[action*="/cart/add"]') || !f.closest('product-form')) return;
    var s = e.submitter;
    if (s && s.name !== 'add') return;
    e.preventDefault(); e.stopImmediatePropagation();
    var btn = f.querySelector('button[name="add"]');
    if (btn) { btn.classList.add('loading'); btn.setAttribute('aria-disabled', 'true'); }
    var fd = new FormData(f); fd.append('sections', 'cart-icon-bubble');
    fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw j; return j; }); })
      .then(function (j) {
        if (j.sections && j.sections['cart-icon-bubble']) {
          var bubble = document.getElementById('cart-icon-bubble');
          if (bubble) { var d = new DOMParser().parseFromString(j.sections['cart-icon-bubble'], 'text/html'); var src = d.querySelector('.shopify-section') || d.body; bubble.innerHTML = src.innerHTML; }
        }
        return fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (c) { setCounts(c.item_count); miniCart(j, c); });
      })
      .catch(function (err) { toast(esc((err && (err.description || err.message)) || 'Could not add. Please try again.')); })
      .finally(function () { if (btn) { btn.classList.remove('loading'); btn.removeAttribute('aria-disabled'); } });
  }, true);

  /* sold-out products go to the end of each grid / rail */
  function soldLast() {
    document.querySelectorAll('.product-grid, .aj-track').forEach(function (g) {
      var kids = [].slice.call(g.children);
      var sold = kids.filter(function (k) { return k.querySelector('[data-aj-soldout]') || (k.matches && k.matches('[data-aj-soldout]')); });
      if (!sold.length || sold.length === kids.length) return;
      var last = kids[kids.length - 1];
      if (sold.indexOf(last) > -1 && sold.every(function (s, i) { return kids.indexOf(s) === kids.length - sold.length + i; })) return;
      sold.forEach(function (s) { g.appendChild(s); });
    });
  }

  /* wishlist page */
  function renderWishlist() {
    var box = document.getElementById('aj-wishlist'); if (!box) return;
    var list = wlGet();
    if (!list.length) { box.innerHTML = '<p class="aj-wl-empty">Your wishlist is empty.<br>Tap the ♡ on any piece to save it here.</p>'; return; }
    box.innerHTML = '<p class="aj-wl-empty">Loading your favourites…</p>';
    Promise.all(list.map(function (h) {
      return fetch(root + 'products/' + encodeURIComponent(h) + '?view=ajcard').then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; });
    })).then(function (cards) {
      box.innerHTML = '<div class="aj-wl-grid">' + cards.join('') + '</div>';
      paintHearts(box);
    });
  }

  /* search hints like "Search 'hoops'" */
  function searchHints() {
    var hints = ['Search "hoops"', 'Search "mangalsutra"', 'Search "adjustable rings"', 'Search "gifts under 699"', 'Search "layered necklace"', 'Search "watches"'];
    var inputs = document.querySelectorAll('input.search__input, input[name="q"]');
    if (!inputs.length) return;
    var i = 0;
    inputs.forEach(function (inp) { inp.placeholder = hints[0]; });
    setInterval(function () {
      i = (i + 1) % hints.length;
      inputs.forEach(function (inp) { if (document.activeElement !== inp && !inp.value) inp.placeholder = hints[i]; });
    }, 2600);
  }

  /* wishlist icon in header, next to account & cart */
  function headerWish() {
    if (!document.getElementById('aj-hwish-css')) { var st = document.createElement('style'); st.id = 'aj-hwish-css'; st.textContent = '.aj-hwish a{display:flex;align-items:center;position:relative;color:inherit;text-decoration:none}.aj-hwish svg{fill:none;stroke:currentColor;stroke-width:1.6;width:24px;height:24px}.aj-hwish .wbhcartitem:empty{display:none}@media(max-width:749px){#google-merchantwidget-iframe-wrapper{display:none!important}}.aj-card--soldout .aj-card__media img{opacity:.55}'; document.head.appendChild(st); }
    document.querySelectorAll('.wbhcart').forEach(function (cart) {
      if (cart.parentElement.querySelector('.aj-hwish')) return;
      var d = document.createElement('div');
      d.className = 'aj-hwish';
      d.innerHTML = '<a href="' + root + 'pages/wishlist" aria-label="Wishlist"><span class="svgbg"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.5s-7.5-4.6-7.5-10.3A4.2 4.2 0 0 1 12 7.6a4.2 4.2 0 0 1 7.5 2.6c0 5.7-7.5 10.3-7.5 10.3z"/></svg></span><span class="wbhcartitem wbqtyboth" data-aj-wl-count></span><span class="wbcarthtotal text-left"><span>Saved</span><strong>Wishlist</strong></span></a>';
      cart.parentElement.insertBefore(d, cart);
    });
  }
  /* support chat: icon in header opens Shopify Inbox; floating bubble hidden */
  function chatRoots() {
    var c = document.querySelector('shopify-chat'), out = [];
    if (c && c.shadowRoot) {
      out.push(c.shadowRoot);
      var rt = c.shadowRoot.querySelector('shopify-agent-runtime');
      if (rt && rt.shadowRoot) out.push(rt.shadowRoot);
    }
    return out;
  }
  function hideBubble() {
    var roots = chatRoots();
    roots.forEach(function (r) {
      if (!r.getElementById('aj-hide-act')) { var s = document.createElement('style'); s.id = 'aj-hide-act'; s.textContent = '.activator{display:none!important}'; r.appendChild(s); }
    });
    return roots.length > 1;
  }
  function openChat() {
    var roots = chatRoots().reverse();
    for (var i = 0; i < roots.length; i++) { var b = roots[i].querySelector('.activator'); if (b) { b.click(); return true; } }
    return false;
  }
  function headerHelp() {
    document.querySelectorAll('.aj-hwish').forEach(function (w) {
      if (w.parentElement.querySelector('.aj-hhelp')) return;
      var d = document.createElement('div');
      d.className = 'aj-hwish aj-hhelp';
      d.innerHTML = '<a href="' + root + 'pages/contact" data-aj-chat aria-label="Chat with us"><span class="svgbg"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4.5 5.5h15v10h-9l-4.5 4v-4h-1.5z" stroke-linejoin="round"/><path d="M8.5 10.5h.01M12 10.5h.01M15.5 10.5h.01" stroke-width="2.2" stroke-linecap="round"/></svg></span><span class="wbcarthtotal text-left"><span>Need help?</span><strong>Chat with us</strong></span></a>';
      w.parentElement.insertBefore(d, w);
    });
    hideBubble();
    var n = 0, t = setInterval(function () { if (hideBubble() || ++n > 60) clearInterval(t); }, 300);
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-aj-chat]');
    if (a && openChat()) {
      e.preventDefault();
      var k = 0, iv = setInterval(function () { if (hideBubble() || ++k > 40) clearInterval(iv); }, 250);
    }
  });
  /* hide the theme's "0" bubble on an empty cart */
  function tidyCartBubble() {
    document.querySelectorAll('.wbhcart .wbhcartitem').forEach(function (el) { el.style.display = el.textContent.trim() === '0' ? 'none' : ''; });
  }

  function init() {
    headerWish(); headerHelp(); tidyCartBubble(); soldLast();
    paintHearts(); setCounts(); renderWishlist(); searchHints();
    fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (c) { setCounts(c.item_count); }).catch(function () {});
    /* re-paint hearts when filters / load-more inject new cards */
    var grid = document.getElementById('ProductGridContainer') || document.querySelector('.aj-coll');
    if (grid && window.MutationObserver) {
      var t; new MutationObserver(function () { clearTimeout(t); t = setTimeout(function () { paintHearts(); soldLast(); }, 120); }).observe(grid.parentNode || grid, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
